import API from "../../utils/api";

export const getProductsApi = async (data) => {
  const response = await API.get(`product`, {
    params: data,
  });
  return { response };
};
export const getProductSetting = async (data) => {
  const response = await API.get(`product/get-product-settings`, {
    params: data,
  });
  return { response };
};

export const getProductCreateSetting = async (data) => {
  const response = await API.get(`product/get-product-create-settings`, {
    params: data,
  });
  return { response };
};

export const addProductApi = async (data) => {
  const response = await API.post("product", data);
  return { response };
};

export const getProductApi = async (id) => {
  const response = await API.get(`product/` + id + "/edit");
  return { response };
};
export const getProductViewApi = async (id) => {
  const response = await API.get(`product/` + id);
  return { response };
};
export const getAIProductViewApi = async (id) => {
  const response = await API.get(`product/${id}/ai-details`);
  return { response };
};
export const getAiTagsBasedOnImageApi = async (data) => {
  const response = await API.get(`product/ai-tags/fetch/${data.product_id}`, {
    params: data,
  });
  return { response };
};
export const getAiFromCGPortalApi = async (data) => {
  const response = await API.get(`product/ai-cg-portal/fetch/${data.product_id}`, {
    params: data,
  });
  return { response };
};
export const updateAIProductDetailsApi = async (data, id) => {
  const response = await API.put(`product/${id}/ai-details/update`, data);
  return { response };
};
export const updateProductApi = async (data, id) => {
  const response = await API.put(`product/${id}`, data);
  return { response };
};
export const getCategoryByTypeId = async (id) => {
  const response = await API.get(`product/get-category/` + id);
  return { response };
};
export const getSubCategoryByCategoryId = async (id) => {
  const response = await API.get(`product/get-sub-category/` + id);
  return { response };
};
export const addProductImageApi = async (id, data) => {
  const response = await API.post("product/upload-image/" + id, data, { "content-type": "multipart/form-data" });
  return { response };
};

export const deleteProductApi = async (id) => {
  const response = await API.delete(`product/delete-image/${id}`);
  return { response };
};

export const sortProductImageApi = async (id, data) => {
  const response = await API.post("product/sort-image/" + id, data);
  return { response };
};

export const bulkProductApi = async (data) => {
  const response = await API.post("product/bulk-product-action", data);
  return { response };
};

export const bulkNewlyCreateAndPublishApi = async (data) => {
  const response = await API.post("product/newly-create-and-publish", data);
  return { response };
};

export const createDuplicateProductApi = async (data) => {
  const response = await API.post("product/create-duplicate-product", data);
  return { response };
};

export const bulkSalesOfferApi = async (data) => {
  const response = await API.post("product/bulk-sales-offer-update", data);
  return { response };
};

export const updateProductImageAltTextApi = async (data) => {
  const response = await API.post("product/update-image-alt-text", data);
  return { response };
};
export const sellerAutoSuggestionApi = async (text) => {
  const response = await API.get("product/seller-auto-suggestion", {
    params: text,
  });
  return { response };
};

export const sellerBrandSuggestionApi = async (text) => {
  const response = await API.get("product/brand-auto-suggestion", {
    params: text,
  });
  return { response };
};
export const taxonomySuggestionApi = async (text) => {
  const response = await API.get("product/taxonomy-auto-suggestion", {
    params: text,
  });
  return { response };
};

export const addProductLookBookApi = async (data) => {
  const response = await API.post("product/look-book/store-product-look-book", data);
  return { response };
};

export const downloadLookBookApi = async (id) => {
  const response = await API.get(`product/look-book/product-look-book/${id}`, { "content-type": "application/pdf", responseType: "blob" });
  return { response };
};

export const checkLookBookTitleApi = async (data) => {
  const response = await API.get("product/look-book/check-look-book_title", {
    params: data,
  });
  return { response };
};

export const getLookBookApi = async (data) => {
  const response = await API.get(`product/look-book/look-book-view`, {
    params: data,
  });
  return { response };
};

export const getCurrencyRateApi = async (price, code) => {
  const response = await API.get(`product/look-book/currency-convert/${price}/${code}`);
  return { response };
};

export const getExportApi = async (data) => {
  const response = await API.get(
    `product/export-stockprice`,
    {
      params: data,
    },
    { "content-type": "application/vnd.ms-excel", responseType: "blob" }
  );
  return { response };
};

export const updateInventoryBulkApi = async (data) => {
  const response = await API.post("product/import-stockprice", data, { "content-type": "multipart/form-data" });
  return { response };
};
export const updateInventoryBulkBySkuApi = async (data) => {
  const response = await API.post("product/inventory/import-by-sku", data, { "content-type": "multipart/form-data", responseType: "json" });
  return { response };
};

export const addProductHolidayOfferApi = async (data) => {
  const response = await API.post("product/holiday-mode", data);
  return { response };
};

export const downloadSampleCsvApi = async () => {
  const response = await API.get("product/download/sample-csv", { "content-type": "application/vnd.ms-excel", responseType: "blob" });
  return { response };
};

export const importProductCsvApi = async (data) => {
  const response = await API.post(`product/import-products`, data);
  return { response };
};

export const importProductsTagsApi = async (data) => {
  const response = await API.post(`product/import-products-tags`, data, { "content-type": "multipart/form-data" });
  return { response };
};

export const importProductsGradeTagsApi = async (data) => {
  const response = await API.post(`product/import-grade-tags`, data, { "content-type": "multipart/form-data" });
  return { response };
};

export const createSentImageApi = async (data) => {
  const response = await API.post("product/send-image", data);
  return { response };
};

export const updateAddtionalApi = async (data, id) => {
  const response = await API.post(`product/additional-details/${id}`, data, { "content-type": "multipart/form-data" });
  return { response };
};

export const getAdditionalSettingsApi = async (id) => {
  const response = await API.get(`product/additional-details/${id}`);
  return { response };
};

export const getProductInfoApi = async (id) => {
  const response = await API.get(`product/get-draft-product/${id}`);
  return { response };
};

export const exportProductsApi = async (data) => {
  const response = await API.get(
    "product/export-usa-products",
    { params: data },
    { "content-type": "application/vnd.ms-excel", responseType: "blob" }
  );
  return { response };
};

export const exportEUProductsApi = async (data) => {
  const response = await API.get(
    "product/export-eu-products",
    { params: data },
    { "content-type": "application/vnd.ms-excel", responseType: "blob" }
  );
  return { response };
};

export const exportMarketplaceProductsApi = async (data) => {
  const response = await API.get(
    "product/export-marketplace-products",
    { params: data },
    { "content-type": "application/vnd.ms-excel", responseType: "blob" }
  );
  return { response };
};

export const exportWalmartProductsApi = async (data) => {
  const response = await API.get(
    "product/export-walmart-products",
    { params: data },
    { "content-type": "application/vnd.ms-excel", responseType: "blob" }
  );
  return { response };
};

export const exportProductsToTBOneApi = async (data) => {
  const response = await API.get("tbone/product-export", { params: data }, { "content-type": "application/vnd.ms-excel", responseType: "blob" });
  return { response };
};

export const exportUSProductsApi = async (data) => {
  const response = await API.get("product/inventory-export", { params: data }, { "content-type": "application/vnd.ms-excel", responseType: "blob" });
  return { response };
};

export const exportLystFeedProductsApi = async (data) => {
  const response = await API.get("product/export-lyst-feed", { params: data });
  return { response };
};

export const exportGroupedProductsApi = async () => {
  const response = await API.get("product/export-group-product-report");
  return { response };
};

export const codeWithColourAutoSuggestion = async (data) => {
  const response = await API.get("product/code-with-colour-auto-suggestion", { params: data });
  return { response };
};

export const codeWithMainWiseColourAutoSuggestion = async (data) => {
  const response = await API.get("product/looklab-main-colour-wise-auto-suggestion", { params: data });
  return { response };
};

export const variantColourWiseAutoSuggestion = async (data) => {
  const response = await API.get("product/variant-colour-wise-auto-suggestion", { params: data });
  return { response };
};

export const syncGTNNumberApi = async (data) => {
  const response = await API.post(`product/sync-gtn-numbers`, data);
  return { response };
};

export const getCheckHolidayOrdersApi = async (data) => {
  const response = await API.post(`seller-product/holiday-orders`, data);
  return { response };
};

export const exportActiveOrdersApi = async (data) => {
  const response = await API.post("product/export-active-orders", data, {
    responseType: 'blob'  
  });
  return { response };
};

export const getSizeQuantityApi = async (data) => {
  const response = await API.get(`product/mystery-product/qty` , { params: data });
  return { response };
};

export const generateAiProductDescriptionApi = async (productId, data = {}) => {
  const response = await API.post(`product/${productId}/ai/description`, data);
  return { response };
};

export const generateAiProductSummaryApi = async (productId, data = {}) => {
  const response = await API.post(`product/${productId}/ai/summary`, data);
  return { response };
};

export const generateAiProductSeoApi = async (productId, data = {}) => {
  const response = await API.post(`product/${productId}/ai/seo`, data);
  return { response };
};

export const generateAiProductImagesApi = async (productId, data = {}) => {
  const response = await API.post(`product/${productId}/ai/generate-images`, data);
  return { response };
};

export const retouchAiProductImagesApi = async (productId, data = {}) => {
  const response = await API.post(`product/${productId}/ai/retouch-images`, data);
  return { response };
};

